import { defaultValues } from '../flags';
import useConfig from './useConfig';

const useAccountConfig = attributes => useConfig(attributes, defaultValues, 'selectedAccountConfig');

export default useAccountConfig;
